export type AskResponse = {
    answer: string;
    citations: Citation[];
    error?: string;
    // uuidContent?: {
    //     id: string;
    //     content: string;
    // };
    selectedModel: string
    message_id?: string;
    chat_Contnet?: string;
    isLoading?: any;
    userQuestion?: any;
    fileUrl?: any;
    isImage?: boolean;
    imageUrl?: string | null;
    image_url?: string;
};

export type Citation = {
    content: string;
    id: string;
    title: string | null;
    filepath: string | null;
    url: string | null;
    metadata: string | null;
    chunk_id: string | null;
    reindex_id: string | null;
    chat_Contnet: string | null;
};

export type ToolMessageContent = {
    citations: Citation[];
    intent: string;
};

export type ChatMessage = {
    createdAt: any;
    id: string;
    role: string;
    content: string;
    end_turn?: boolean;
    date: string;
    ispdf?: boolean;
    pdfurl?: any;
    isimage?: any;
    Email?: any;
    is_search_active?: any;
    modelname?: any;
    isImage?: boolean;
    imageUrl?: string | null;
    image_url?: string;
};

export type Message = {
    id: string;
    message: string;
};

export type Conversation = {
    id: string;
    title: string;
    messages: ChatMessage[];
    date: string;
};

export type SingleConversation = {
    messages: ChatMessage[];
};

export enum ChatCompletionType {
    ChatCompletion = "chat.completion",
    ChatCompletionChunk = "chat.completion.chunk"
}

export type ChatResponseChoice = {
    files: any;
    messages: ChatMessage[];
}

export type ChatResponse = {
    files: any;
    followups: [];
    id: string;
    model: string;
    created: number;
    object: ChatCompletionType;
    choices: ChatResponseChoice[];
    history_metadata: {
        conversation_id: string;
        title: string;
        date: string;
    };
    error?: any;
};

export type ConversationRequest = {
    messages: ChatMessage[];
};

export type UserInfo = {
    access_token: string;
    expires_on: string;
    id_token: string;
    provider_name: string;
    user_claims: any[];
    user_id: string;
};

export enum CosmosDBStatus {
    NotConfigured = "CosmosDB is not configured",
    NotWorking = "CosmosDB is not working",
    Working = "CosmosDB is configured and working",
}

export type CosmosDBHealth = {
    cosmosDB: boolean;
    status: string;
};

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export type ErrorMessage = {
    title: string;
    subtitle: string;
};
